import type { ReactNode } from "react";

import FullscriptLogoGreenLeafPigeonTextSVGComponent from "@shared/assets/logo/FullscriptLogoGreenLeafPigeonText";

import * as styles from "./OAuthOnboardingHeader.styles";

interface Props {
  applicationLogo: string;
  rightContent?: ReactNode;
}

const OAuthOnboardingHeader = ({ applicationLogo, rightContent }: Props) => {
  return (
    <div css={styles.header}>
      <FullscriptLogoGreenLeafPigeonTextSVGComponent css={styles.fsLogo} />
      <div css={styles.partnerLogoContainer}>
        <img src={applicationLogo} css={styles.partnerLogo} />
      </div>
      {!!rightContent && <div css={styles.rightSlot}>{rightContent}</div>}
    </div>
  );
};

export { OAuthOnboardingHeader };
